import React from "react";
import { Clock, FileText, Monitor, Shield } from "lucide-react";
import SearchBar from "components/search/SearchBar";

const FullHeaderComponent = (props) => {
  const {
    icon: Icon,
    title,
    subtitle,
    hyvidScope,
    workArrangement,
    reviewTime,
    placeholder="Search policy...",
  } = props;

  const hasAnyChips = [hyvidScope, workArrangement, reviewTime]
  .some(val => val && val.trim?.());

  return (
    <div className="">
      <div className="bg-gradient-to-r from-emerald-600 to-purple-600 text-white px-6 py-5 relative">
        
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Icon className="w-6 h-6" />
            <div>
              <h1 className="text-lg font-bold">{title}</h1>
              <p className="text-xs opacity-80 mt-0.5">{subtitle}</p>
            </div>
          </div>

          <div className="sm:flex items-center gap-2 text-xs opacity-70 bg-white/10 rounded-lg px-3 py-1.5">
            <Shield className="w-3.5 h-3.5" />
            <span>Confidential · Internal Use Only</span>
          </div>
        </div>
        
        {hasAnyChips && (
          <div className="mt-3 flex flex-wrap gap-2">
            {hyvidScope && (
              <span className="flex items-center gap-1.5 bg-white/15 rounded-full px-2.5 py-1 text-xs font-medium">
                <FileText className="w-3 h-3" />
                {hyvidScope}
              </span>
            )}

            {workArrangement && (
              <span className="flex items-center gap-1.5 bg-white/15 rounded-full px-2.5 py-1 text-xs font-medium">
                <Monitor className="w-3 h-3" />
                Work arrangement: {workArrangement}
              </span>
            )}

            {reviewTime && (
              <span className="flex items-center gap-1.5 bg-white/15 rounded-full px-2.5 py-1 text-xs font-medium">
                <Clock className="w-3 h-3" />
                Review: {reviewTime}
              </span>
            )}
          </div>
        )}
        <div className="mt-4 relative">
          <SearchBar
            placeholder={placeholder}
            searchWrapperClass="w-full bg-white/20 text-white text-sm rounded-lg border border-white/20 focus-within:ring-0 focus-within:shadow-none"
            inputClassName="text-white [&_.ant-input]:placeholder-white/60"
            inputIconClass="text-white/70"
          />
        </div>
      </div>
    </div>
  );
};

export default FullHeaderComponent;